import { render } from "./Controls.vue?vue&type=template&id=b74996cc&scoped=true"
import script from "./Controls.vue?vue&type=script&lang=js"
export * from "./Controls.vue?vue&type=script&lang=js"

import "./Controls.vue?vue&type=style&index=0&id=b74996cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b74996cc"]])

export default __exports__